import * as React from 'react';

const SvgCheckLocalWeatherOutline = (props) => (
  <svg
    data-name='Layer 2'
    xmlns='http://www.w3.org/2000/svg'
    width={'1em'}
    height={'1em'}
    viewBox='22 22 84 84'
    {...props}
  >
    <g data-name='Layer 1'>
      <path
        d='M98.26 63.59c2.48-3.48 3.87-7.66 3.87-12.01 0-11.4-9.27-20.68-20.68-20.68-10.36 0-18.89 7.7-20.37 17.63-8.23 1-15.45 6.01-19.24 13.32-1.26-.3-2.57-.52-3.92-.52-9.01 0-16.32 7.31-16.32 16.32s7.31 16.32 16.32 16.32h52.24c9.01 0 16.32-7.31 16.32-16.32 0-6.05-3.35-11.27-8.23-14.1v.04Zm-16.8-26.16c7.79 0 14.15 6.36 14.15 14.15 0 3.74-1.52 7.27-4.18 9.92-.44 0-.83-.13-1.26-.13-1.35 0-2.66.17-3.92.52-3.74-7.23-10.62-12.14-18.59-13.32 1.39-6.36 7.05-11.14 13.8-11.14Zm8.71 50.06H37.93c-5.4 0-9.79-4.4-9.79-9.79s4.4-9.79 9.79-9.79c1.48 0 2.92.3 4.27.96h.17s.09.04.13.09c.22.09.39.09.61.09.13 0 .3.09.44.09h.04c.35 0 .7-.04 1-.17.13 0 .26-.13.35-.17.22-.09.44-.22.61-.35.13-.09.26-.22.35-.35.13-.17.26-.35.39-.52.04-.09.17-.17.22-.26 0-.04 0-.13.04-.17 0 0 .04-.09.04-.13 2.66-7.31 9.62-12.19 17.41-12.19s14.15 4.44 17.06 11.32c.04.13.17.22.22.35.04.3.09.57.22.87.78 1.61 2.74 2.31 4.35 1.52 1.35-.65 2.74-.96 4.27-.96 5.4 0 9.79 4.4 9.79 9.79s-4.4 9.79-9.79 9.79h.04Z'
        style={{
          fill: 'currentColor',
        }}
      />
    </g>
  </svg>
);
export default SvgCheckLocalWeatherOutline;
